import { flow, getOr } from 'lodash/fp';

import selectCart from '../select-cart';

const getOrNull = getOr(null);
const selectCartProductId = flow(selectCart, getOrNull('product.id'));

export default selectCartProductId;
